export default "__VITE_ASSET__b481b705__"